import { useTranslation } from 'react-i18next';
import {
  Answer,
  type CreateDataRequestDto,
  ReasonForDataRequest,
} from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { FormRadio, ConditionalField } = typedFormFields<CreateDataRequestDto>();

export const LegalObligation = () => {
  // Heeft de desbetreffende netbeheerder(s) een wettelijke verplichting om deze data te verstrekken?
  const { t } = useTranslation('dataRequest');
  const YesNoDontKnowOptions = [
    {
      label: t(`answer.${Answer.Yes}`),
      value: Answer.Yes,
    },
    {
      label: t(`answer.${Answer.No}`),
      value: Answer.No,
    },
    {
      label: t(`answer.${Answer.DontKnow}`),
      value: Answer.DontKnow,
    },
  ];

  return (
    <ConditionalField
      field="legalObligation"
      condition={(formValue) => {
        return formValue('reason') === ReasonForDataRequest.LegalObligation;
      }}
    >
      <FormRadio
        name="legalObligation"
        label={t('legal_obligation')}
        options={YesNoDontKnowOptions}
        rules={{ required: true }}
      />
    </ConditionalField>
  );
};
